// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__vfv5Q","actions":"styles_actions__16-Hd","error":"styles_error__3YtQw","message":"styles_message__IBl2u"};